export const messages = {
  en: {
    orderManage: {
      queryCondition: 'Query Condition',
      orderList: 'Order List',
      orderId: 'Order ID',
      externalId: 'External ID',
      businessId: 'Business ID',
      startTime: 'Start Time',
      endTime: 'End Time',
      operator: 'Operator',
      businessName: 'Business Name',
      appName: 'App Name',
      createTime: 'Create Time',
      action: 'Action',
      actionObj: 'Action Object',
      status: 'Status',
      operation: 'Operation',
      log: 'Log',
      noLog: 'No Log',
      add: 'Add',
      modify: 'Modify',
      delete: 'Delete',
      completed: 'Completed',
      failed: 'Failed',
      allApps: 'All Apps',
      fetchError: 'Failed to fetch orders',
      fetchAppsError: 'Failed to fetch apps'
    },
    viewUnItemLog: {
      title: 'Order Log',
      serviceName: 'Service Name',
      action: 'Action',
      actionObj: 'Action Object',
      preValue: 'Before Value',
      afterValue: 'After Value',
      logText: 'Original Log',
      add: 'Add',
      modify: 'Modify',
      delete: 'Delete',
      fetchError: 'Failed to fetch log'
    }
  },
  zh: {
    orderManage: {
      queryCondition: '查询条件',
      orderList: '受理单',
      orderId: '订单编号',
      externalId: '外部编号',
      businessId: '业务编号',
      startTime: '受理开始时间',
      endTime: '受理结束时间',
      operator: '操作人',
      businessName: '业务名称',
      appName: '应用名称',
      createTime: '受理时间',
      action: '受理动作',
      actionObj: '受理表',
      status: '状态',
      operation: '操作',
      log: '日志',
      noLog: '无日志',
      add: '添加',
      modify: '修改',
      delete: '删除',
      completed: '完成',
      failed: '失败',
      allApps: '全部应用',
      fetchError: '获取订单列表失败',
      fetchAppsError: '获取应用列表失败'
    },
    viewUnItemLog: {
      title: '受理记录',
      serviceName: '受理服务',
      action: '受理动作',
      actionObj: '受理表',
      preValue: '受理前',
      afterValue: '受理后',
      logText: '原始记录',
      add: '添加',
      modify: '修改',
      delete: '删除',
fetchError: '获取日志失败'
    }
  },
  'zh-TW': {
    orderManage: {
      queryCondition: '查詢條件',
      orderList: '受理單',
      orderId: '訂單編號',
      externalId: '外部編號',
      businessId: '業務編號',
      startTime: '受理開始時間',
      endTime: '受理結束時間',
      operator: '操作人',
      businessName: '業務名稱',
      appName: '應用名稱',
      createTime: '受理時間',
      action: '受理動作',
      actionObj: '受理表',
      status: '狀態',
      operation: '操作',
      log: '日誌',
      noLog: '無日誌',
      add: '添加',
      modify: '修改',
      delete: '刪除',
      completed: '完成',
      failed: '失敗',
      allApps: '全部應用',
      fetchError: '獲取訂單列表失敗',
      fetchAppsError: '獲取應用列表失敗'
    },
    viewUnItemLog: {
      title: '受理記錄',
      serviceName: '受理服務',
      action: '受理動作',
      actionObj: '受理表',
      preValue: '受理前',
      afterValue: '受理後',
      logText: '原始記錄',
      add: '添加',
      modify: '修改',
      delete: '刪除',
      fetchError: '獲取日誌失敗'
    }
  }
}